module.exports = __webpack_public_path__ + "static/media/EAI-08.615ad897.jpg";